var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOldMainBlock)?_c('main-block'):(_vm.showMainBlock)?_c('main-block-with-overview'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }